import { Table } from '../../../../components/general/table';
import { OrbitHistoryFilter } from '../types';
import { useOrbitHistoryList } from './hook';

type Props = {
    filters?: OrbitHistoryFilter;
};

export const OrbitHistoryList = ({ filters }: Props) => {
    const {
        columns,
        rows,
        loading,
        page,
        pageSize,
        paginator,
        total,
        onRowClick,
    } = useOrbitHistoryList(filters);

    return (
        <Table
            columns={columns}
            rows={rows}
            getRowId={(row) => row.id || row.case_number}
            rowCount={total}
            loading={loading}
            paginationModel={{
                page,
                pageSize,
            }}
            onPaginationModelChange={paginator}
            pageSizeOptions={[2, 10, 20, 50]}
            disableRowSelectionOnClick
            onRowClick={(params, event) => {
                if ((event.target as Element).closest('.no-click-cell')) {
                    return;
                }
                onRowClick(params);
            }}
        />
    );
};
